(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-core-wager/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-core-wager/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.mybets_core_wager = {
  api_calls: {},
  parsers: {},
  utils: {
    conditionals: {}
  },
  logger: new svs.core.log.Logger('numbergames:mybets-core-wager')
};

 })(window);